import offerService from '~/services/offerService'

export const useOfferStore = defineStore('OfferStore', {
  state: () => {
    return {
      offerId: null,
      packageId: null,
      tickets: [],
      hotels: [],
      rooms: [],
      outwardFlightId: null,
      returnFlightId: null,
      maxChanges: 0,
      passengers: {},
      failedServices: []
    }
  },

  getters: {},

  actions: {
    wrap (offer) {
      this.offerId = offer.offerId ?? null
      this.packageId = offer.packageId ?? null
      this.tickets = offer.tickets ?? []
      this.outwardFlightId = offer.outwardFlightId ?? null
      this.returnFlightId = offer.returnFlightId ?? null
      this.maxChanges = offer.maxChanges ?? 0
      this.hotels = offer.hotels ?? []
      this.rooms = offer.rooms ?? []
      this.passengers = offer.passengers ?? []
    },
    async get (offerId) {
      const { offerLink } = await offerService.get(offerId)

      return offerLink
    },
    async create (link) {
      const { offerId } = await offerService.create(link)

      return offerId
    },
    addFailedService (failedService) {
      this.failedServices.push(failedService)
    }
  }
})
